import { Modal } from "../Modal";
import { TModalProps } from "../Modal";

import { PrimaryButton } from "../ButtonPrimary";
import StyledWrapper from "./style";

export const SuccessModal = ({
  urlTittle,
  show,
  modalTitle,
  modalSubtitle,
  onClose,
  paramsToCleanOnClose,
}: TModalProps) => {
  // TODO: Width should be dynamic
  return (
    <StyledWrapper.SuccessModalContainer>
      <Modal
        show={show}
        urlTittle={urlTittle}
      >
        <div className="flex flex-col items-center gap-5 w-[580px]">
          <img src="/images/succesIcon.svg" alt="BurgerMenu" />

          <h1 className="font-bold text-xl text-[#444444] text-center px-12">
            {modalTitle}
          </h1>
          <p className="text-[#777777] text-center">{modalSubtitle}</p>
          <PrimaryButton
            type="button"
            text="Aceptar"
            onClick={onClose}
            styles=" bg-red-500 font-bold text-white w-52 mb-4"
          />
        </div>
      </Modal>
    </StyledWrapper.SuccessModalContainer>
  );
};
